import React, { useEffect } from 'react';
import * as S from './style-3';
import Image from '../../../components/loggedout/common/Image';
import { fetchImageUrlForNewOnboarding, getItemFromLocalStorage } from '../../../utils/web-helper';
export var LoadThroughScreenThree = function (props) {
    var ResourcesData = getItemFromLocalStorage('loadthrough-screen-3');
    var interval1;
    useEffect(function () {
        interval1 = setTimeout(function () {
            props.goToNextHandler('load_through_screen_3', {});
        }, 4000);
        return function () { return clearInterval(interval1); };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Heading, null, "Finishing up with more exciting resources"),
        React.createElement(S.BaseBg, null, ResourcesData['loadthrough-screen-3'].map(function (data, index) { return (React.createElement(S.ResourceWrapper, { key: index, top: data.top, left: data.left },
            React.createElement(S.ResourceIcon, null,
                React.createElement(Image, { src: fetchImageUrlForNewOnboarding(data.path, data.image), alt: "resource-icon" })),
            React.createElement(S.ResourceText, null, data.title))); }))));
};
export default LoadThroughScreenThree;
